/*=========================================================================================
  File Name: i18n.js
  Description: Thiết lập localize
  ----------------------------------------------------------------------------------------
  Author: PDKIEN
  Author URL: https://misa.com.vn
==========================================================================================*/

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import viMessages from './vi/index';

Vue.use(VueI18n);

//Khởi tạo i18n — chỉ load vi ngay từ đầu, các locale khác lazy load khi cần
let i18n = new VueI18n({
	locale: 'vi',
	fallbackLocale: 'vi',
	silentTranslationWarn: true,
	messages: { vi: viMessages }
});

export const loadedLocales = ['vi'];

//formatXML rules (i18nFormatXML/i18nFormatXML70) rất nặng (~7600 dòng), chỉ dùng ở popup CheckingXmlInfoDetail
//=> tách khỏi bundle chính, lazy load theo locale khi thực sự cần
const loadedFormatXmlLocales = [];
i18n.loadFormatXmlMessages = async function() {
	const locale = this.locale;
	if (loadedFormatXmlLocales.includes(locale)) return;
	const [formatXML, formatXML70] = await Promise.all([
		import(/* webpackChunkName: "i18n-formatXML-[request]" */ `./${locale}/formatXML/i18nFormatXML`),
		import(/* webpackChunkName: "i18n-formatXML70-[request]" */ `./${locale}/formatXML/i18nFormatXML70`)
	]);
	//Không dùng getLocaleMessage/mergeLocaleMessage của vue-i18n: cả 2 đều JSON-clone hoặc merge đệ quy
	//theo key, làm mất function (vd TooltipInvalidSeries) và biến Array format-rule thành plain object.
	//=> gắn thẳng 2 namespace mới (chưa tồn tại) vào object messages hiện có bằng Vue.set để giữ nguyên type.
	const localeMessages = this._vm.messages[locale] || {};
	this._vm.$set(localeMessages, 'i18nFormatXML', formatXML.default);
	this._vm.$set(localeMessages, 'i18nFormatXML70', formatXML70.default);
	this._vm.$set(this._vm.messages, locale, localeMessages);
	loadedFormatXmlLocales.push(locale);
};


//Thêm thuộc tính isVietnamese vào i18n
Object.defineProperty(i18n, 'isVietnamese', {
	get() {
		return this.locale === 'vi';
	}
});

//Thêm thuộc tính isEnglish vào i18n
Object.defineProperty(i18n, 'isEnglish', {
	get() {
		return this.locale === 'en';
	}
});

//Cập nhật ngôn ngữ — async để đảm bảo messages đã load trước khi render
i18n.updateLocale = async function(newLocale) {
	if (!loadedLocales.includes(newLocale)) {
		const messages = await import(
			/* webpackChunkName: "i18n-[request]" */
			`./${newLocale}/index`
		);
		i18n.setLocaleMessage(newLocale, messages.default);
		loadedLocales.push(newLocale);
	}
	this.locale = newLocale;
};

export default i18n;
